export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-2-09ec5bc4efc5f41ea5807cf67c862ccf.jpg";